export class VerifyUserPhoneModel {
  constructor(
    public customerId: string,
    public typeOfVerificationMethodCode: string,
    public maskedPhoneNumber: string,
    public partnerId?: string,
    public experienceId?: string
  ) {}
}
